import { GridColDef } from '@mui/x-data-grid-pro';
import moment from 'moment';

import { IcDotSpread } from '@/assets/images';
import { Button } from '@/components/TailwindComponents';
import { VehicleMaintenanceStatus } from '@/models';

import { maintenanceStatusLabelMap } from './data';

const date = (): Partial<GridColDef> => ({
  field: 'date',
  headerName: 'Date',
  sortable: true,
  valueFormatter: (value: any) => {
    if (!value) return '';
    return moment(value).isValid() ? moment(value).format('MM/DD/YYYY') : value;
  },
});

const expirationDate = (): Partial<GridColDef> => ({
  field: 'expirationDate',
  headerName: 'Expiration date',
  sortable: true,
  valueFormatter: (value: any) => {
    if (!value) return '';
    return moment(value).isValid() ? moment(value).format('MM/DD/YYYY') : value;
  },
});

const maintenanceType = (): Partial<GridColDef> => ({
  field: 'maintenanceType',
  headerName: 'Maintenance type',
  sortable: true,
  renderCell: (params) => {
    const value = params.value?.name;

    return value;
  },
});

const description = (): Partial<GridColDef> => ({
  field: 'description',
  headerName: 'Description',
  sortable: true,
});

const repairedBy = (): Partial<GridColDef> => ({
  field: 'repairedBy',
  headerName: 'Repaired by',
  sortable: true,
});

const cost = (): Partial<GridColDef> => ({
  field: 'cost',
  headerName: 'Cost',
  sortable: true,
  valueFormatter: (value: any) => {
    if (!value && value !== 0) return '';
    return `$${value}`;
  },
});

const status = (): Partial<GridColDef> => ({
  field: 'status',
  headerName: 'Status',
  sortable: true,
  valueFormatter: (value: VehicleMaintenanceStatus) => {
    if (!value) return '';
    return maintenanceStatusLabelMap[value] || value;
  },
});

const actions = (
  openMenu?: (event: React.MouseEvent<HTMLButtonElement>, param: any) => void,
): Partial<GridColDef> => ({
  field: 'actions',
  headerName: 'Actions',
  sortable: false,
  renderCell: (params) => (
    <Button
      variant="ghost"
      size="sm"
      onClick={(e) => {
        e.stopPropagation();
        openMenu?.(e, params.row);
      }}
      className="p-1 h-8 w-8"
    >
      <IcDotSpread />
    </Button>
  ),
});

export const vehicleMaintenanceCols = (
  openMenu?: (event: React.MouseEvent<HTMLButtonElement>, param: any) => void,
) => {
  return {
    date,
    expirationDate,
    maintenanceType,
    description,
    repairedBy,
    cost,
    status,
    actions: () => actions(openMenu),
  };
};
